import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import calendarReducer from "./calendarSlice";

export default configureStore({
  reducer: {
    bookmark: userReducer,
    calendar: calendarReducer,
  },
  //To stop error of serializable of Date Object
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
